/**
 * Loại báo cáo
 */
export const ReportType = {
  /**
   * Tình hình sử dụng
   */
  UseState: 1,

  /**
   *  Tình hình công việc
   */
  WorkState: 2,

  /**
   *  Cơ cấu công việc theo loại việc
   */
  StructureByWorkType: 3,

  /**
   *  Tình hình công việc theo loại việc
   */
  StateByWorkType: 4,

  /**
   *  Tình hình thực hiện công việc
   */
  StateExecuteWork: 5,

  /**
   *  Thống kê công việc theo loại việc
   */
  StatisticsByWorkType: 6,

  /**
   *  So sánh tình hình thực hiện công việc
   */
  CompareStateExecuteWork: 7,

  /**
   *  Tổng quan công việc
   */
  WorkOverall: 8,

  /**
   *  Tổng quan công việc
   */
  WorkOverview: 9,

  /**
   *  Tổng quan tình hình thực hiện công việc theo vai trò
   */
  WorkStateOverviewByRole: 10,

  /**
   *  Tổng quan loại việc theo vai trò
   */
  WorkTypeOverviewByRole: 11,

  /**
   *  Tổng quan tình hình thực hiện công việc theo vai trò và loại việc
   */
  WorkStateOverviewByRoleAndWorkType: 12,

  /**
   *  Công việc đc ủy quyền
   */
  AuthorizationWork: 13,

  /**
   *  Nhắc việc
   */
  RemindWork: 14,

  /**
   *  Tình hình thực hiện công việc để thực hiện
   */
  WorkStateToExecute: 15,

  /**
   *  Tình hình thực hiện công việc để đánh giá
   */
  WorkStateToEvaluate: 16,

  /**
   *  Tình hình công việc theo loại việc chi tiết
   */
  StateByWorkTypeDetail: 17,

  /**
    * Cơ cấu công việc theo loại việc vhi tiết
    */
  StructureByWorkTypeDetail: 18,

  /**
   *  Tình hình công việc chi tiết
   */
  WorkStateDetail: 19,
};

/**
 * Loại biểu đồ
 */
export const ChartType = {
  /**
   * Bảng
   */
  Table: 1,

  /**
   * Tròn
   */
  Circle: 2,

  /**
   * Thẻ
   */
  Card: 3,
};

/**
 * Các view màn tổng quan
 */
export const ReportView = {
  /**
   * Đơn vị của tôi
   */
  MyOrg: 1,

  /**
   * Chủ quản
   */
  OperateByMe: 2,

  /**
   * Cá nhân
   */
  Personality: 3,
}

export const ReportRoleType = {
  /**
   * Người chủ trì
   */
  Executor: 1,

  /**
   * Người giao việc
   */
  Assigner: 2,

  /**
   * Người phối hợp
   */
  Combination: 3,

  /**
   * Người liên quan
   */
  Involved: 4,

  // Người phụ trách
  Supervisor: 5,
}

/**
 * Loại sort
 */
export const SortType = {
  /**
   * Giảm dần
   * */
  DESC : 1,
  /**
   * Tăng dần
   */
  ASC: 2
}

/// <summary>
/// Tình trạng công việc
/// </summary>
export const TaskState = {
  /// <summary>
  /// Tất cả
  /// </summary>
  None : 0,

  /// <summary>
  /// Hoàn thành đúng hạn
  /// </summary>
  SuccessInTime : 1,

  /// <summary>
  /// Hoàn thành trễ hạn
  /// </summary>
  SuccessOutTime : 2,

  /// <summary>
  /// Chưa hoàn thành trong hạn
  /// </summary>
  InProcessInTime : 3,

  /// <summary>
  /// Chưa Hoàn thành trễ hạn
  /// </summary>
  InProcessOutTime : 4,

  /// <summary>
  /// Ko hoàn thành
  /// </summary>
  NotSuccess : 5,

  /// <summary>
  /// Chưa hoàn thành
  /// </summary>
  InProcess: 6,

  /// <summary>
  /// Hoàn thành
  /// </summary>
  Success: 7,
}